/* Won't Miss Garage Sheets connector v1.0 (08 Sep 2026)
   Posts a JSON payload to the Google Apps Script web app configured in Theme settings > Google Sheets.
   Apps Script web apps only accept opaque no-cors requests from a browser, so the response can't be read;
   the promise resolves with 'sent', 'blocked' (network error / no URL) or 'timeout'.
   keepalive keeps the request alive if the page navigates right after (the Shopify backup form posts next).
   Apps Script update reminder: Deploy > Manage deployments > pencil > New version. A "New deployment" makes a new URL. */
(function () {
  'use strict';
  var WMG = window.WMG = window.WMG || {};
  var KEEPALIVE_LIMIT = 60000; /* bytes; browsers cap keepalive bodies at 64KB */

  window.WMGSheets = {
    version: '1.0',
    send: function (payload, opts) {
      opts = opts || {};
      var sheets = (WMG.config && WMG.config.sheets) || {};
      var url = opts.url || sheets.webhook;
      var timeoutMs = opts.timeoutMs || sheets.timeoutMs || 8000;
      if (!url || !window.fetch) return Promise.resolve('blocked');

      var body;
      try {
        body = JSON.stringify(Object.assign({
          connector: 'wmg-' + this.version,
          submitted_at: new Date().toISOString(),
          page: window.location.href,
          user_agent: navigator.userAgent
        }, payload));
      } catch (e) {
        return Promise.resolve('blocked');
      }

      var request = fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: body.length < KEEPALIVE_LIMIT,
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: body
      }).then(function () { return 'sent'; }).catch(function () { return 'blocked'; });

      var timer = new Promise(function (resolve) { setTimeout(function () { resolve('timeout'); }, timeoutMs); });
      return Promise.race([request, timer]);
    }
  };
})();
